import React from 'react';
import './Footer.css';
import { SERVICES } from '../data/services';
import {
  getDisclaimerPath,
  getPrivacyPolicyPath,
  getServicePath,
  isHomePagePath,
} from '../utils/routes';

const BuildingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

const QUICK_LINKS = [
  { label: 'Home', id: 'home' },
  { label: 'Services', id: 'services' },
  { label: 'About', id: 'about' },
  { label: 'Contact', id: 'contact' },
];

const LEGAL_LINKS = [
  { label: 'Privacy Policy', href: getPrivacyPolicyPath() },
  { label: 'Disclaimer', href: getDisclaimerPath() },
];

const Footer = () => {
  const isHomePage = isHomePagePath(window.location.pathname);

  const scrollTo = (id) => {
    if (!isHomePage) {
      window.location.href = id === 'home' ? '/' : `/#${id}`;
      return;
    }

    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        {/* Brand column */}
        <div className="footer__col footer__col--brand">
          <div className="footer__brand">
            <span className="footer__brand-icon"><BuildingIcon /></span>
            <span className="footer__brand-name">Thar Enterprises</span>
          </div>
          <p className="footer__tagline">
            Your trusted partner for business registration and compliance services.
          </p>
        </div>

        {/* Quick Links column */}
        <div className="footer__col">
          <h4 className="footer__col-title">Quick Links</h4>
          <ul className="footer__list">
            {QUICK_LINKS.map(({ label, id }) => (
              <li key={id}>
                <button className="footer__link" onClick={() => scrollTo(id)}>
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Our Services column */}
        <div className="footer__col">
          <h4 className="footer__col-title">Our Services</h4>
          <ul className="footer__list">
            {SERVICES.map((service) => (
              <li key={service.id}>
                <a className="footer__link" href={getServicePath(service.slug)}>
                  {service.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__col-title">Legal</h4>
          <ul className="footer__list">
            {LEGAL_LINKS.map((link) => (
              <li key={link.href}>
                <a className="footer__link" href={link.href}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="container">
          <p className="footer__copy">
            © {year} Thar Enterprises. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
